// ICE COLD JEWELRY — small runtime helpers.

(() => {
  // Logo and hero films always play, even with "Reduce motion" on (they are the brand, and the
  // owner wants them running); a refused autoplay (Low Power Mode) retries on the first touch.
  const kick = () => {
    document.querySelectorAll('.ice-video-logo video, .ice-hero video').forEach((video) => {
      if (video.paused) video.play().catch(() => {});
    });
  };

  // Mobile gets its own vertical poster frame while the film loads.
  if (window.matchMedia('(max-width: 749px), (orientation: portrait)').matches) {
    document.querySelectorAll('.ice-hero video[data-poster-mobile]').forEach((video) => {
      video.poster = video.dataset.posterMobile;
    });
  }

  kick();
  ['touchstart', 'scroll', 'click'].forEach((type) => window.addEventListener(type, kick, { once: true, passive: true }));
  document.addEventListener('shopify:section:load', kick);
})();
